import { useEffect, useRef, useState } from "react";

export interface AuraMetrics {
  focus: "Calm" | "Alert" | "Drowsy";
  perclos: number; // % eye closure
  mar: number; // mouth aspect ratio (yawn)
  yaw: number; // head yaw degrees
  cleanShiftSec: number;
  pulse: number;
}

/** Smoothly-oscillating behavioural-intelligence telemetry for the Safety Aura. */
export function useAura(): AuraMetrics {
  const [m, setM] = useState<AuraMetrics>({
    focus: "Calm",
    perclos: 8,
    mar: 0.12,
    yaw: 2,
    cleanShiftSec: 4 * 3600 + 12 * 60,
    pulse: 64,
  });
  const start = useRef(Date.now());

  useEffect(() => {
    const id = setInterval(() => {
      const t = (Date.now() - start.current) / 1000;
      const perclos = 8 + Math.sin(t / 7) * 6 + Math.max(0, Math.sin(t / 23) * 14);
      const mar = 0.12 + Math.max(0, Math.sin(t / 11) * 0.22);
      const yaw = Math.sin(t / 4) * 14;
      const focus = perclos > 20 ? "Drowsy" : perclos > 14 ? "Alert" : "Calm";
      setM({
        focus,
        perclos: Math.round(perclos * 10) / 10,
        mar: Math.round(mar * 100) / 100,
        yaw: Math.round(yaw),
        cleanShiftSec: 4 * 3600 + 12 * 60 + Math.floor(t),
        pulse: 64 + Math.round(Math.sin(t / 5) * 6),
      });
    }, 1000);
    return () => clearInterval(id);
  }, []);

  return m;
}

export function fmtClock(sec: number): string {
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  return `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}
